<!--
 * @Description: 报价成功弹框组件
 * @Author: fal
 * @FilePath: \pc.ui\src\project\components\quoteModal.vue
 * @LastEditTime: 2024-12-07 13:46:11
-->
<template>
  <el-dialog class="quote-modal" :visible="dialogVisible" width="360px" top="15%" :show-close="false" append-to-body>
    <div class="modal-content">
      <img src="@/project/assets/pay-icon.png" alt="" class="del-icon" />
      <p class="del-text">{{ text }}</p>
      <div class="button-group">
        <el-button class="cancel-btn" @click="handleCancel">关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'quoteModal',
  props: {
    text: {
      type: String,
      default: '报价已完成！',
    },
  },
  data() {
    return {
      dialogVisible: true,
    };
  },
  methods: {
    handleCancel() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.quote-modal {
  :deep(.el-dialog) {
    border-radius: 8px;
    background: url('@/project/assets/del-bg.png') no-repeat center;
    background-size: cover;
    height: 203px;
  }

  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .del-icon {
    position: absolute;
    top: -72px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 140px;
  }

  .del-text {
    margin: 24px 0 26px;
    font-size: 20px;
    font-weight: 800;
    color: #333;
  }

  .button-group {
    display: flex;
    justify-content: center;
  }

  .cancel-btn {
    font-size: 20px;
    width: 248px;
    border-radius: 22px;
    border: 1px solid rgba(27, 112, 255, 1);
    color: rgba(27, 112, 255, 1);
  }
}
</style>
